import React from 'react'
import { LiaFolderOpenSolid } from 'react-icons/lia'
import { IoIosArrowForward } from 'react-icons/io'
import { formatRouteForPush, Routes } from '@/core/router/routes'
import { Link } from 'react-router-dom'
import { Card } from '@tecsinapse/cortex-react'
import clsx from 'clsx'
import { CONST_ROOT_NAME } from '../utils/constants'
import { ItemBiblioteca } from '@/core/types/graphql'

interface BreadcrumbsPastasProps {
  pasta: ItemBiblioteca
}

export const BreadcrumbsPastas: React.FC<BreadcrumbsPastasProps> = ({
  pasta
}) => {
  const nomeRaiz = CONST_ROOT_NAME

  const defaultProps = (id: string | undefined, title: string) => ({
    title,
    to: formatRouteForPush(
      id ? Routes.BIBLIOTECA_VIRTUAL_PASTA : Routes.BIBLIOTECA_VIRTUAL,
      [id]
    )
  })

  const breadcrumbs = [
    defaultProps(undefined, nomeRaiz), // Item raiz
    ...(pasta.breadcrumb ?? []).map(pasta =>
      defaultProps(pasta?.id, String(pasta?.nome))
    )
  ]

  return (
    <Card className={'mb-deca py-mili'}>
      <div className='flex flex-row items-center space-x-2'>
        {breadcrumbs.map((breadcrumb, idx) => (
          <div key={idx} className='flex flex-row items-center space-x-2'>
            <Link
              to={breadcrumb.to}
              className='flex items-center space-x-2 text-gray-800 hover:text-primary-medium no-underline'
            >
              <LiaFolderOpenSolid className='text-primary-medium' />
              <p
                className={clsx(
                  idx === breadcrumbs.length - 1
                    ? 'text-secondary-medium'
                    : 'text-black'
                )}
              >
                {breadcrumb.title}
              </p>
            </Link>
            {idx !== breadcrumbs.length - 1 && (
              <IoIosArrowForward className='text-gray-500' />
            )}
          </div>
        ))}
      </div>
    </Card>
  )
}
